module.exports = __webpack_public_path__ + "img/icon_douyin.33bdf23d.png";